import React, { Component } from "react";
import { Button, Form,Image } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import "./Abha.css";
import ReCAPTCHA from "react-google-recaptcha";
import Aadhaar from "./Aadhaar.png";
import mobile from "./mobile.png";
export default class ABHANumberVerification extends Component {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      abhanumber: ["", "", "", ""],
      showAbha: false,
     authMethods: "",
      captchaToken: null,
      apiMessage: "",
    };
  }
  handleImageClick = (option) => {
    this.setState({ authMethods: option });
  };
    showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };
  HandleBackSubmit=()=>{
    window.location="./abharegister"
  }
  handleabhaIdChange = (index, value) => {
    const updated = [...this.state.abhanumber];
    const limit = index === 0 ? 2 : 4;
    updated[index] = value.replace(/\D/g, "").slice(0, limit);
    this.setState({ abhanumber: updated });
  };

  // handleImageClick = (option) => {
  //   this.setState({ authMethods: option });
  // };

  handleCaptchaChange = (value) => {
    this.setState({ captchaToken: value });
  };

  handleSubmitNext = (e) => {
    e.preventDefault();
    const { abhanumber, captchaToken,authMethods } = this.state;
    const fullabhanumber = abhanumber.join("-");
    const abhaPlain = abhanumber.join("");
    const abhaRegex = /^\d{14}$/;

    if (!abhaRegex.test(abhaPlain)) {
      this.showToast("ABHA number must be exactly 14 digits.", "error");
      return;
    }

    if (!captchaToken) {
      this.showToast("Please verify the captcha.", "error");
      return;
    }

    sessionStorage.setItem("abhanumber", fullabhanumber);

    const formData = new FormData();
    formData.append("abhanumber", fullabhanumber);
     formData.append("authMethods", authMethods);
    formData.append("captchaToken", captchaToken);
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhaverify/submitAbhaNumber", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          const message = data.details?.message || "ABHA number verified!";
          this.setState({ apiMessage: message }); 
          this.showToast("ABHA number verified!", "success");
          sessionStorage.setItem("message", message);
          sessionStorage.setItem("requestId", data.requestId || this.state.requestId);
           window.location.href = "/abhanumberverifyotp"; // redirect to OTP screen
        } else {
        
          const errorMessage =
          data.details?.error?.message || data.message || "Verification failed";
         this.showToast(errorMessage, "error");
         setTimeout(() => {
          window.location.href = "/consentcollectionaadhaar";
        }, 5000);
        }
      })
      
  };

  handleAbhaKeyDown = (e, index) => {
    const key = e.key;
    const value = e.target.value;
  
    if (key === "Backspace" && value === "" && index > 0) {
      this[`abhaInput${index - 1}`]?.focus();
    }
  
    // If user completes the field, move to next input
    if (key !== "Backspace") {
      const maxLen = index === 0 ? 2 : 4;
      const currentVal = e.target.value;
      setTimeout(() => {
        if (currentVal.length >= maxLen && index < 3) {
          this[`abhaInput${index + 1}`]?.focus();
        }
      }, 10);
    }
  };
  render() {
    const { abhanumber, showAbha,authMethods } = this.state;

    return (
      <div>
        <div className="row justify-content-md-center text-center abhaverification">
         

          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>
                  <b>Enter ABHA Number</b>
                </Form.Label>
                <div className="d-flex gap-2">
                {abhanumber.map((val, idx) => (
                  <Form.Control
                    className="otp-input-box"
                    key={idx}
                    ref={(input) => (this[`abhaInput${idx}`] = input)} // store ref
                    id={`abhanumber-${idx}`}
                    type={showAbha ? "text" : "password"}
                    value={val}
                    onChange={(e) => this.handleabhaIdChange(idx, e.target.value)}
                    onKeyDown={(e) => this.handleAbhaKeyDown(e, idx)} // handle backspace
                    maxLength={idx === 0 ? 2 : 4}
                    placeholder={idx === 0 ? "XX" : "XXXX"}
                  />
                ))}

                  <Button 
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      showAbha ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() => this.setState({ showAbha: !showAbha })}
                  />
           



                </div>
                <div className="row justify-content-md-center selectAadhaarMobileOtp">
                  <p>Validate using</p>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("aadhaarotp")}
                      style={{
                        border:
                          authMethods === "aadhaarotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={Aadhaar}
                        className=""
                        alt="Aadhaar"
                        style={{
                          width: "auto",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Aadhaar OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "aadhaarotp"}
                      />
                    </div>
                  </div>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("mobileotp")}
                      style={{
                        border:
                          authMethods === "mobileotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={mobile}
                        className="navbar-brand pe-3 ps-4 ps-lg-2"
                        alt="Mobile"
                        style={{
                          width: "auto",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Mobile OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "mobileotp"}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex mt-3">
                  <ReCAPTCHA
                    className="mt-2"
                    ref={this.recaptchaRef}
                    sitekey={configData.captchaKey}
                    onChange={this.handleCaptchaChange}
                  />
                </div>

              </Form.Group>
              

            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
        <div className="col text-start">
        
        <Button className="rounded-0 m-1 " variant="warning"
            onClick={this.HandleBackSubmit}
        
        >
          Back
        </Button>
        </div>
        <div className="col text-end"> <Button
                  className="rounded-0 m-3"
                  onClick={this.handleSubmitNext}
                >
                  Verify ABHA Number
                </Button></div>
                </div>
      </div>
    );
  }
}
